module.exports = __webpack_public_path__ + "img/ic_share.73e1be66.svg";